import  * as actionTypes from "./actionTypes";
import { DateFilter } from "../types/DateFilter";
import { Tabs } from "../types/Constants";
import { RequestData, AddFeedBack, ResolveFeedback, ReplyFeedback } from "../types/ContentRequest";

export const getSentContentRequest = () => {
    return {
        type: actionTypes.GET_SENT_CONTENT_REQUEST,
    }
}

export const getContentRequest = (payload: RequestData) => {
    return {
        type: actionTypes.GET_CONTENT_REQUEST,
        payload: payload
    }
}

export const getOwnerTaskByRoleData = (requestId: string, authorType: string) => {
    return {
        type: actionTypes.GET_OWNER_TASK_BY_ROLE,
        payload: {requestId, authorType}
    }
}
export const addNewFeedback = (feedbackData: AddFeedBack) => {
    return {
        type: actionTypes.ADD_NEW_FEEDBACK,
        payload: feedbackData
    }
}
export const resolveFeedback = (feedbackData: ResolveFeedback) => {
    return {
        type: actionTypes.RESOLVE_FEEDBACK,
        payload: feedbackData
    }
}
export const replyFeedback = (feedbackData: ReplyFeedback) => {
    return {
        type: actionTypes.REPLY_FEEDBACK,
        payload: feedbackData
    }
}
export const getFeedback = (contentRequestId: string, contentId: string, pageNumber: number) => {
    return {
        type: actionTypes.GET_FEEDBACK,
        payload: {contentRequestId, contentId, pageNumber}
    }
}
export const getReceivedContentRequest = () => {
    return {
        type: actionTypes.GET_RECEIVED_CONTENT_REQUEST
    }
}

export const setActiveTab = (activeTab: Tabs) => {
    return {
        type: actionTypes.SET_ACTIVE_TAB,
        payload: activeTab
    }
}

export const setDateFilter = (dateFilterType: DateFilter) => {
    return {
        type: actionTypes.SET_DATE_FILTER,
        payload: dateFilterType
    }
}

export const toggleStatus = (payload: any) => {
    return {
        type: actionTypes.TOGGLE_STATUS,
        payload: payload
    }
}

export const toggleContentType = (payload: any) => {
    return {
        type: actionTypes.TOGGLE_CONTENT_TYPE,
        payload: payload
    }
}

export const togglePriority = (payload: any) => {
    return {
        type: actionTypes.TOGGLE_PRIORITY,
        payload: payload
    }
}

export const setSearchText = (searchData: any) => {
    return {
        type: actionTypes.SET_SEARCH_TEXT,
        payload: searchData
    }
}

export const deleteContentRequest = (id: string) => {
    return {
        type: actionTypes.DELETE_CONTENT_REQUEST,
        payload: id
    }
}

export const editContentRequest = (id: string) => {
    return {
        type: actionTypes.EDIT_CONTENT_REQUEST,
        payload: id
    }
}

export const updateCurrentPage = (payload: number) => {
    return {
        type: actionTypes.UPDATE_CURRENT_PAGE,
        payload: payload
    }
}

export const nextPage = (payload: any) => {
    console.log(payload)
    return {
        type: actionTypes.NEXT_PAGE,
        payload: payload
    }
}

export const previousPage = (payload: any) => {
    console.log(payload);
    return {
        type: actionTypes.PREVIOUS_PAGE,
        payload: payload
    }
}

export const firstPage = (payload: Tabs) => {
    return {
        type: actionTypes.FIRST_PAGE,
        payload: payload
    }
}

export const lastPage = (payload: Tabs) => {
    return {
        type: actionTypes.LAST_PAGE,
        payload: payload
    }
}

export const fetchSubjects = (payload:any)=>{
    return {
        type: actionTypes.FETCH_SUBJECTS,
        payload: payload
    }
}
export const addSubject = (payload:any)=>{
    return {
        type: actionTypes.ADD_SUBJECT,
        payload: payload
    }
}
export const fetchOwners = (payload:any)=>{
    return {
        type: actionTypes.FETCH_OWNERS,
        payload: payload
    }
}

export const setUserByRole=(payload:any)=>{
    return {
        type: actionTypes.ADD_AUTHOR_ROLE,
        payload: payload
    }
}